module.exports = __webpack_public_path__ + "static/usecase_consignment_profile@2x-cc278e0bad658da26831cccd40dbd4ad.png";